import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useRemainingViewportHeight } from 'app/hooks';

interface RemainingViewportHeightContainerProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const RemainingViewportHeightContainer: React.FC<RemainingViewportHeightContainerProps> = ({
  children,
  className,
  style,
}) => {
  const [componentRef, componentHeight] = useRemainingViewportHeight();

  const containerStyle: React.CSSProperties = {
    height: componentHeight,
    ...style,
  };

  return (
    <Box ref={componentRef} className={className} style={containerStyle}>
      {children}
    </Box>
  );
};

export default RemainingViewportHeightContainer;